import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from './components/pages/home';
import PrivacyPolicy from './components/pages/legal/PrivacyPolicy';
import TermsOfService from './components/pages/legal/TermsOfService';
import Products from './components/pages/products';
import Login from './components/pages/auth/Login';
import OrderHistory from './components/pages/orders/OrderHistory';
import ScrollToTop from './components/common/ScrollToTop';

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/products' element={<Products />} />
        <Route path='/login' element={<Login />} />
        <Route path='/orders' element={<OrderHistory />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/terms-of-service' element={<TermsOfService />} />
        <Route path='*' element={<Home />} />
      </Routes>
    </Router>
  );
}